"use client";
import React, { useEffect, useRef, useState } from "react";
import GetInstantQuoteButton from "@/components/Contact/GetInstantQuote";
import Image from "next/image";
import { useTranslations } from "next-intl";
const ContactBanner = () => {
	const t = useTranslations("contactUS");
	const [isVisible, setIsVisible] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				const entry = entries[0];
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect(); // 动画触发后停止观察
				}
			},
			{
				root: null, // 使用浏览器视窗为根
				threshold: 0.1, // 当元素 10% 可见时触发
			},
		);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current);
			}
		};
	}, []);

	return (
		<div className="bg-black text-white">
			<div ref={ref} className=" grid grid-cols-1 items-center md:grid-cols-2 ">
				{/* 左侧图片部分 */}
				<div className={`relative ${isVisible ? "animate__animated animate__fadeInLeft" : "opacity-0"}`}>
					<Image
						quality={50}
						width={1000}
						height={1000}
						src="/image/contact/bg.jpg"
						alt="Contact Us"
						className="h-[550px] w-full object-cover object-top max-md:h-[350px]"
					/>
				</div>

				{/* 右侧文本和按钮部分 */}
				<div className={`pl-8 ${isVisible ? "animate__animated animate__fadeInRight" : "opacity-0"}`}>
					<h1 className="mb-6 text-4xl font-bold">{t("Contact Us")}</h1>
					<p className="animate__animated animate__fadeInRight animate__slower w-5/6 text-gray-400">
						{t("Get in touch")}
					</p>
					<div className="mt-8 inline-block">
						<GetInstantQuoteButton />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactBanner;
